import { red } from '@material-ui/core/colors';
import { dropRight } from 'lodash';
import { whiteColor, boxShadow } from '../global';

const organizerListPageStyle = (theme) => ({
    noPadding: {
        '& > div': {
            padding: 0,
        },
    },
    wrapper: {
        backgroundColor: (props) => props?.settings_colors_viewer?.screen_background_color || whiteColor,
    },
    searchLabel: {
        [theme.breakpoints.up('sm')]: {
            textAlign: 'right',
        },
    },
    checkboxHeader: {
        color: whiteColor,
        '&$checkboxHeaderChecked': {
            color: whiteColor,
        },
    },
    checkboxHeaderChecked: {},
    firstButton: {
        marginRight: theme.spacing(1),
    },
    zoneTitle: {
        lineHeight: '20px',
        marginBottom: '10px',
    },
    buttonBig: {
        fontSize: '30px !important',
        whiteSpace: 'normal',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            whiteSpace: 'normal',
        },
    },
    headerCenterButton: {
        padding: 0,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
    searchingButton: {
        backgroundColor: '#cc0000',
        height: '45px',
        width: '45px',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        borderRadius: '4px',
        '&:hover,&:focus': {
            background: '#cc0000',
        },
    },
    imgSearchIcon: {
        width: '35px',
        height: '35px',
    },
    buttonAddFavorite: {
        '& > span > svg': {
            marginRight: '0px',
        },
        borderRadius: '5px',
        marginBottom: '10px',
        fontWeight: 'bold',
        fontSize: '14px',
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
        padding: '4px 0',
    },
    hiddenSearchWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
        padding: '4px 0',
        visibility: 'hidden',
    },
    searchPaper: {
        width: '500px',
    },
    popperSearch: {
        padding: theme.spacing(1),
    },
    container: {
        direction: 'row',
        justify: 'space-between',
        alignItems: 'stretch',
        textAlign: 'center',
    },
    items: {
        '& img': {
            width: '100%',
            height: 200,
            maxWidth: 200,
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            objectFit: 'contain',
        },
        '& p': {
            marginBottom: 40,
            wordBreak: 'break-word',
            color: (props) => props?.settings_colors_viewer?.contents_text_color,
        },
    },
    switchWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px 0',
    },
    switchLabel: {
        marginRight: '16px',
        fontSize: '18px',
        color: (props) => props?.eventInfo?.settings_colors_viewer?.contents_text_color,
    },
    sectionWrapper: {
        marginBottom: '30px',
    },
    centerToRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    buttonBig2: {
        fontSize: '30px !important',
        minWidth: '450px !important',
        padding: '10px !important',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '360px !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px !important',
            minWidth: '280px !important',
        },
    },
    helperText: {
        maxWidth: '480px',
        [theme.breakpoints.down('md')]: {
            maxWidth: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    colorTextInput: {
        '& input': {
            color: '#4b4b4b',
        },
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
    customList: {
        color: (props) => props.eventInfo?.settings_colors_viewer?.contents_text_color || '#333',
        margin: '0 0 0 -20px',
    },
    layoutFirstItem: {
        [theme.breakpoints.up('sm')]: {
            paddingBottom: '40px',
        },
    },
    containerLayoutFirst: {
        direction: 'row',
        justify: 'space-between',
        alignItems: 'stretch',
        textAlign: 'center',
    },
    layoutFirstProductName: {
        height: '45px',
        color: (props) => props?.text_color_company_name || '#ed735b',
        fontWeight: 'bold',
        fontSize: '16px',
        marginBottom: '5px',
        textAlign: 'Center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
    },
    layoutFirstCompanyName: {
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        height: '44px',
        '& span': {
            fontSize: '14px',
        },
    },
    layoutFirstCompanyType: {
        textAlign: 'end',
        paddingBottom: '10px',
        '& span': {
            fontSize: '14px',
        },
    },
    layoutFirstProductItem: {
        marginBottom: '25px',
        backgroundColor: '#fff',
        maxWidth: '300px',
        margin: 'auto',
        '&:hover': {
            transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
            ...boxShadow,
        },
    },
    layoutFirstProductThumbnail: {
        position: 'relative',
        display: 'block',
        overflow: 'hidden',
        border: '0.5px solid #f0f0f0',

        '&:before': {
            display: 'block',
            paddingTop: '100%',
            content: '" "',
        },
    },
    layoutFirstProductItemImg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    layoutFirstProductItemIcon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '50%',
    },
    layoutFirstProductMeta: {
        paddingTop: '5px',
    },
    layoutFirstTable: {
        padding: '0 0 20px 0',
    },
    layoutFirst: {
        padding: 0,
    },
});

export default organizerListPageStyle;
